import { Select } from 'antd';
import { useGetRegionsQuery } from 'gql/types';
import { EditUserInfoSchema } from 'modules/admin/components/EditUserForm/schema';
import { FC, useMemo } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FormItem from '../FormItem';

type Props = {
  control: { control: Control<EditUserInfoSchema> };
  disabled?: boolean;
  onRegionsChange?: (regionIds: string[]) => void;
};

const AssignedRegionsSelect: FC<Props> = ({
  control,
  disabled,
  onRegionsChange,
}) => {
  const { t } = useTranslation('common.AssignedRegionsSelect');

  const { data: regionsData, loading } = useGetRegionsQuery();
  const regions = regionsData?.getRegions || [];

  const regionOptions = useMemo(() => {
    return (
      regions.map((region) => ({
        label: region.name,
        value: region.id,
      })) ?? []
    );
  }, [regionsData]);

  return (
    <FormItem label={t('assignedRegions')}>
      <Controller
        name="assignedRegionIds"
        control={control.control}
        render={({ field }) => (
          <Select
            {...field}
            mode="multiple"
            disabled={disabled}
            loading={loading}
            options={regionOptions}
            placeholder={t('selectRegions')}
            allowClear
            onChange={(values) => {
              field.onChange(values);
              onRegionsChange?.(values);
            }}
          />
        )}
      />
    </FormItem>
  );
};

export default AssignedRegionsSelect;
